import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserState } from "../authentication/types/user";
import { DEFAULT_AVATAR } from '../constants/avatars';

const initialState: UserState = {
  userCode: null,
  userName: null,
  role: null,
  lang: null,
  token: null,
  authenticated: false,
  expire_at: null,
  avatar: DEFAULT_AVATAR,
  email: null,
};

export const userSlice = createSlice({
  name: "userState",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<UserState>) => {
      const { userCode, userName, role, token, authenticated} = action.payload;
      state.userCode = userCode;
      state.userName = userName;
      state.role = role;
      state.token = token;
      state.authenticated = authenticated;
     },
    logout: (state, action: PayloadAction<boolean | undefined>) => {
      state.authenticated = action.payload || false;
      state = initialState;
    },
    updateAvatar: (state, action: PayloadAction<string>) => {
      state.avatar = action.payload;
    },
    updateUserDetails: (state, action: PayloadAction<Partial<Pick<UserState, 'avatar' | 'email' | 'lang'>>>) => {
      if (action.payload.avatar !== undefined && action.payload.avatar !== null) {
        state.avatar = action.payload.avatar;
      }
      
      if (action.payload.email !== undefined) {
        state.email = action.payload.email;
      }

      if (action.payload.lang !== undefined) {
        state.lang = action.payload.lang;
      }
    },
  },
});

export const { login, logout, updateAvatar, updateUserDetails } = userSlice.actions;

export default userSlice.reducer;
